import { QuestionCategory } from "../../api";

type Result = {
  title: string;
  description: string;
};

type ScoreResult = Result & {
  maxScore: number;
};

const results: Record<QuestionCategory, ScoreResult[]> = {
  [QuestionCategory.Depression]: [
    {
      maxScore: 9,
      title: "Normální",
      description:
        "Zdá se, že se deprese nemusíš bát. Daří se ti držet ji pod kontrolou. Jen tak dál!",
    },
    {
      maxScore: 13,
      title: "Mírná",
      description:
        "Deprese to na tebe občas zkouší, ale daří se ti ji zvládat. Pokud by toho na tebe bylo moc, neboj se říct si o pomoc!",
    },
    {
      maxScore: 20,
      title: "Středně závažná",
      description:
        "Občas s tebou deprese trochu zacvičí, ale většinou se ti daří držet ji pod kontrolou. Neboj se ale říct si o odbornou pomoc, ať na to nejsi sám/sama!",
    },
    {
      maxScore: 27,
      title: "Závažná",
      description:
        "V životě to někdy není vůbec jednoduché, ale nemusíš na to být sám/sama. Neboj se říct si o pomoc buď u svého zaměstnavatele, na pracovišti krizové intervence (aktuální kontakty ti sdělí na lince 158), nebo nám napiš do poradenského centra Centra dopravního výzkumu (veronika.kureckova@cdv.gov.cz).",
    },
    {
      maxScore: Infinity,
      title: "Extrémně závažná",
      description:
        "O depresi toho víš hodně. A i když s ní bojuješ statečně, rozhodně bys na to neměl/a být sám/sama. Neboj se říct si o pomoc buď u svého zaměstnavatele, na pracovišti krizové intervence (aktuální kontakty ti sdělí na lince 158), nebo nám napiš do poradenského centra Centra dopravního výzkumu (veronika.kureckova@cdv.gov.cz).",
    },
  ],

  [QuestionCategory.Anxiety]: [
    {
      maxScore: 7,
      title: "Normální",
      description:
        "Úzkost se ti vyhýbá obloukem! I nadále tomu můžeš pomoct tím, že se budeš starat o svoji psychickou pohodu!",
    },
    {
      maxScore: 9,
      title: "Mírná",
      description:
        "Úzkost se občas ukáže, ale většinou si s ní umíš dobře poradit. Kdyby toho někdy na tebe bylo moc, neboj se říct si o pomoc!",
    },
    {
      maxScore: 14,
      title: "Středně závažná",
      description:
        "Úzkost občas vystřčí drápky, ale tobě se daří ji zvládnout,. Nemusíš na to ale být sám. Neboj se říct si o odbornou pomoc,když to bude potřeba!",
    },
    {
      maxScore: 19,
      title: "Závažná",
      description:
        "Úzkost je tvůj stálý parťák. Možná to tak ale nemusí být napořád. Neboj se říct si o pomoc, buď u svého zaměstnavatele, na pracovišti krizové intervence (aktuální kontakty ti sdělí na lince 158), nebo nám napiš do poradenského centra Centra dopravního výzkumu (veronika.kureckova@cdv.gov.cz).",
    },
    {
      maxScore: Infinity,
      title: "Extrémně závažná",
      description:
        "Úzkost je denní součástí tvého života a rozhodně to nemáš jednoduché. Určitě bys na to ale neměl/a být sám/sama. Neboj se říct si o pomoc u svého zaměstnavatele, na pracovišti krizové intervence (aktuální kontakty ti sdělí na lince 158), nebo nám napiš do poradenského centra Centra dopravního výzkumu (veronika.kureckova@cdv.gov.cz).",
    },
  ],

  [QuestionCategory.Stress]: [
    {
      maxScore: 14,
      title: "Normální",
      description:
        "Asi ses narodil/a na šťastné planetě, nebo to prostě umíš a stres se ti vyhýbá! I nadále dělej všechno proto, aby stresu bylo ve tvém, životě co nejméně. Možná ti k tomu pomůže i naše aplikace...",
    },
    {
      maxScore: 18,
      title: "Mírná",
      description:
        "Někdy je to jednodušší, jindy těžší, ale většinou se ti daří mít stres pod kontrolou. I nadále se věnuje své psychické pohodě a dělej co nejvíce věcí, které ti dělají radost. A kdyby přišly horší časy, vzpoň si, že na to nikdy nemusíš být sám/sama a neboj se říct si o pomoc!",
    },
    {
      maxScore: 25,
      title: "Středně závažná",
      description:
        "Někdy máš stres pod kontrolou, jindy má stres pod kontrolou tebe. Snaž se dopřát co nejvíce prostoru věcem a lidem, kteří tě udržují v pohodě. A pokud je toho někdy moc, neboj se vyhledat odbornou pomoc. Nemusíš na to být sám/sama!",
    },
    {
      maxScore: 33,
      title: "Závažná",
      description:
        "Stres je tvůj trvalý nepřítel, a i když s ním bojuješ statečně, někdy je toho opravdu hodně. Neboj se říct si o pomoc, buď u svého zaměstnavatele, nebo na pracovišti krizové intervence (aktuální kontakty ti sdělí na lince 158), nebo nám napiš do poradenského centra Centra dopravního výzkumu (veronika.kureckova@cdv.gov.cz).",
    },
    {
      maxScore: Infinity,
      title: "Extrémně závažná",
      description:
        "Většinou je toho na tebe opravdu moc. Určitě si ale zasloužíš, aby s to změnilo. Možná ti se stresem pomůže i naše aplikace, ale neboj se říct si také o odbornou pomoc. U svého zaměstnavatele, na pracovišti krizové intervence (aktuální kontakty ti sdělí na lince 158). Můžeš nám taky napsat do poradenského centra Centra dopravního výzkumu (veronika.kureckova@cdv.gov.cz).",
    },
  ],
};

export const getResult = (category: QuestionCategory, score: number): Result => {
  if (!Number.isFinite(score) || score < 0 || !Number.isInteger(score)) {
    throw new Error("Invalid score");
  }

  const result = results[category]?.find((item) => score <= item.maxScore);

  if (!result) {
    throw new Error("Invalid category or score");
  }

  return {
    title: result.title,
    description: result.description,
  };
};
